import MoveManger from "../../../../gd/manager/move-manager"
import Task from "../../../../model2/task/task"
import ProjectSession from "../../../../model2/project/project-session"

type ModalMoveTo_commitParams = {
    taskToMove          : Task
    targetProject       : ProjectSession
    newSortPosition?    : number
}

export default function ModalMoveTo_commitTaskMoveToFolder(params: ModalMoveTo_commitParams, onMoveCallback?: {(selectedProjectId?: ID): void} ) {
    MoveManger.moveAndSortTaskToProject(params.taskToMove.id, params.targetProject.id, params.taskToMove.userIds, params.newSortPosition, () => {
        onMoveCallback?.()
        gd.modal.hide()
    })
}